import { ChangeDetectorRef, Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'nc-emoji-switch',
  templateUrl: './emoji-switch.component.html',
  styleUrls: ['./emoji-switch.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmojiSwitchComponent),
      multi: true
    }
  ]
})
export class EmojiSwitchComponent implements ControlValueAccessor {
  @Input() set ncDisabled(value: boolean | string) {
    this.disabledMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  @Input() ncSize: 'small' | 'default' | 'large' = 'default';
  disabledMode: boolean = false;
  private innerValue: boolean = false;
  private onChangeCallback: (_: any) => void = () => { };
  private onTouchedCallback: () => void = () => { };

  constructor(private cd: ChangeDetectorRef) { }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  // 从模型写入值到视图
  writeValue(value: any): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
      this.cd.markForCheck();
    }
  }

  // 注册 onChange 事件
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  // 注册 onTouched 事件
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  onInputChange(event: any): void {
    this.value = event;
  }
}
